import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function IsForYouSection() {
  const isForYou = ['Llegás cansada y no sabés qué cocinar', 'Querés comer rico sin complicarte', 'Buscás recetas con ingredientes comunes', 'Querés dejar de gastar en delivery', 'Necesitás opciones rápidas para la familia', 'Cocinás todos los días pero sin ganas'];
  const isNotForYou = ['Buscás recetas gourmet o de chef', 'Querés técnicas avanzadas de cocina', 'No te interesa cocinar en absoluto', 'Esperás un curso con videos largos'];
  return <section className="py-20 bg-orange-50" data-id="element-149">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-150">
        <h2 className="text-3xl lg:text-4xl font-serif font-bold text-gray-900 mb-12 text-center" data-id="element-151">
          ¿Esto es para vos?
        </h2>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-152">
          {/* YES Column */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-green-100" data-id="element-153">
            <div className="flex items-center gap-3 mb-6 border-b border-gray-100 pb-4" data-id="element-154">
              <div className="bg-green-100 p-2 rounded-full" data-id="element-155">
                <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-156" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-157">
                Sí, es para vos si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-158">
              {isForYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-159">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-160" />
                  <span className="text-gray-700" data-id="element-161">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NO Column */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-red-100 opacity-90" data-id="element-162">
            <div className="flex items-center gap-3 mb-6 border-b border-gray-100 pb-4" data-id="element-163">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-164">
                <XCircleIcon className="w-6 h-6 text-red-600" data-id="element-165" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-166">
                No es para vos si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-167">
              {isNotForYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-168">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-169" />
                  <span className="text-gray-600" data-id="element-170">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}